export default {
    meta: {
        title: '机会点废弃库',
        url: '/standardstore/chancerecyclelist',
        urlName: '标准版拓店-机会点',
    }
};
